import React, { useContext } from 'react';
import { Text } from '../Typography';
import { useTranslation } from 'react-i18next';
import { AppContext } from 'src/mtska-frontend-app-scaffolding';

const ActiveModuleName = ({ currentModuleScope, currentModuleName, logo }) => {
    const { t, i18n } = useTranslation();
    const safeT = (key, fallback = key, options) => {
        const lang = i18n.resolvedLanguage || i18n.language || 'it';
        const translatedValue = i18n.getResource(lang, 'translation', key);
        return translatedValue !== undefined ? t(key, options) : fallback;
    };

    const { userCapabilities } = useContext(AppContext);

    const translatedScope = safeT(currentModuleScope, currentModuleScope);
    const translatedModuleName = safeT(currentModuleName, currentModuleName);

    return (
        userCapabilities && Object.keys(userCapabilities).length > 0 && (
            <div className="modulename">
                {logo && <div className="logo" dangerouslySetInnerHTML={{ __html: logo }} />}

                {!userCapabilities['auth/role.is_driver'] && (
                    <Text level="h2">
                        {currentModuleScope && <span className="scope">{translatedScope}</span>}
                        {translatedModuleName?.toLowerCase() !== translatedScope?.toLowerCase() &&
                            translatedModuleName
                        }
                    </Text>
                )}

                {userCapabilities['auth/role.is_driver'] && (
                    <Text level="h2">
                        {t('My')} <span className="scope">{t('Mobility')}</span>
                    </Text>
                )}
            </div>
        )
    );

}

export default ActiveModuleName;